<div class="container ready-for-tablet">
    <div class="row" style="padding: 1em">
        <div
            class="col-md-8 col-sm-12 offset-md-2 offset-sm-0 text-center mb-4"
        >
            <div id="has-driver-log-note-complete">
                <img
                    src="/assets/images/rft-banner.png"
                    alt="Ready for Tablet!"
                    class="mb-4 img-fluid"
                />
            </div>
            <div class="delivery-header">
                <h1 class="mt-3 bold">Preparing For Shipment</h1>
                <img
                    src="/assets/images/rft-graphic.png"
                    alt="Mailing Issue Graphic"
                    class="mt-4"
                    style="max-width: 100%"
                />
                <p class="mt-4 description-grey">
                    You can expect your tablet to ship in the next 5-7 business
                    days. We will text you your FedEx tracking number when your
                    tablet leaves our office.
                </p>
            </div>
            <hr class="mt-4" style="border-top: 2px solid #cccccc" />
            <div class="delivery-header">
                <h2 class="mt-4 bold">Delivery Details</h2>
                <p class="mt-4 description-grey">Shipping Address</p>
                <p class="mt-2 description">{{ address }}</p>

                <!-- <h3 class="mt-5 bold">Start earning now!</h3>
                <p class="mt-4 description">
                    Earn $25 every time a driver you refer starts driving with
                    the tablet. Share your personal referral code
                    <span class="bold">{{ referral_code }}</span> or your
                    personal link:
                    <a href="{{ referral_link }}" id="rft-referral-link">{{ referral_link }}</a> today!
                </p> -->
                <span class="mt-4 mb-5"
                    >Questions?
                    <a
                        class="link"
                        target="_blank"
                        href="https://playoctopus.com/help"
                        id="rft-help-link"
                        >playoctopus.com/help</a
                    ></span
                >
            </div>
        </div>
    </div>
</div>
